import { useEffect } from 'react'
import { useFlag, useFlagsStatus, useUnleashContext } from '@unleash/proxy-client-react'

import { usePersonalUserData } from './usePersonalUserData'

import { IUnleashFlag, IFlagStatus } from './types'

export const useUnleashFlag = (featureName: string): IUnleashFlag => {
  const isFlagEnabled = useFlag(featureName)
  const status: IFlagStatus = useFlagsStatus()
  const { userEmail, userPlanCode, userRole } = usePersonalUserData()
  const updateContext = useUnleashContext()
  

  useEffect(() => {
    void updateContext({ 
      userId: userEmail,
      properties: {
        'planCode': userPlanCode,
        'userRole': userRole,
      } 
    })
    // eslint-disable-next-line
  }, [userEmail, userPlanCode, userRole])
  
  const hasError = !!status.flagsError?.message
  const showFeature = !hasError && status.flagsReady && isFlagEnabled

  return {
    showFeature
  }
}